/***
 * ADM-FILTERS-DEFAULT
 * Get list of custom filters and disable them
 */

import { connect } from "react-redux"
import { WithTranslation, withTranslation } from "react-i18next"
import { Session } from "@/redux/_session.types"
import { store } from "@/index"
import Space from "@/components/space"
import { STATUS_SAVED, STATUS_SAVE_ERROR, STATUS_SAVING } from "@/redux/_status.types"
import { Filter, FilterPopulation, FilterState } from "@/redux/filter.types"
import { filterActivate, filterEdit, filterStatus, filterUpdate } from "@/redux/filter.actions"
import ListCell from "@/components/list-cell"
import SaveIcon from "@/components/save-icon"
import Checkbox from "@/components/checkbox"
import { USER_LIST_GENDER } from "@/redux/user.types"
import getUserFilterDates, { UserFilterDates } from "@/utils/get-user-filter-dates.utils"
import { accountUpdateOptions } from "@/redux/account.actions"
import { sessionEditAccountOptions } from "@/redux/_session.actions"

interface StateProps extends WithTranslation {
  _session: Session
  filter: FilterState
}

//Columns for filter array
const COLUMN_NAME_WIDTH: number = 220 //Width of name column
const COLUMN_POPULATIONS_WIDTH: number = 150 //Width of populatations column

function AdmFiltersRoute(props: StateProps) {
  const { t } = props

  const defaultFilters: Filter[] = [
    new Filter({
      id: "gender",
      name: "user_gender",
      default: true,
      isVisible: props._session.accountOptions.genderShowFilter,
      populations: USER_LIST_GENDER.filter((x: any) => x.id !== null).map(
        (x: any) => new FilterPopulation({ ...x, name: t(x.name), usersCount: 0 })
      )
    }),
    new Filter({
      id: "birthDate",
      name: "user_birth_date_alt",
      default: true,
      isVisible: props._session.accountOptions.birthDateShowFilter,
      populations: getUserFilterDates("BIRTH_DATE", new Date()).map((x: UserFilterDates) => new FilterPopulation(x))
    }),
    new Filter({
      id: "companyWelcomeDate",
      name: "user_company_welcome_date_alt",
      default: true,
      isVisible: props._session.accountOptions.companyWelcomeDateShowFilter,
      populations: getUserFilterDates("COMPANY_WELCOME_DATE", new Date()).map(
        (x: UserFilterDates) => new FilterPopulation(x)
      )
    })
  ]

  async function toggleFilter(filter: Filter) {
    store.dispatch(filterStatus(STATUS_SAVING))
    store.dispatch(filterEdit("isVisible", !filter.isVisible))
    filter.isVisible = !filter.isVisible
    store.dispatch(filterActivate(filter))
    if (filter.default) {
      store.dispatch(sessionEditAccountOptions(filter.id + "ShowFilter", filter.isVisible))
      const response: any = await store.dispatch(accountUpdateOptions(props._session.accountOptions))
      store.dispatch(filterStatus(response.error ? STATUS_SAVE_ERROR : STATUS_SAVED))
    } else {
      const response: any = await store.dispatch(filterUpdate(filter))
      store.dispatch(filterStatus(response.error ? STATUS_SAVE_ERROR : STATUS_SAVED))
    }
  }

  return (
    <div>
      {t("filters_default")}

      {defaultFilters.map((filter: Filter, index: number) => (
        <div className="flex" style={{ margin: "18px 0px" }} key={index}>
          <ListCell>
            <Checkbox
              onClick={props.filter.status === STATUS_SAVING ? null : () => toggleFilter(filter)}
              active={filter.isVisible}
            />
            <Space />
          </ListCell>

          <ListCell width={COLUMN_NAME_WIDTH}>{t(filter.name)}</ListCell>

          <div className="flex1 grey-t flex flex-wrap" style={{ minWidth: COLUMN_POPULATIONS_WIDTH }}>
            {filter.populations
              .slice(0, 3)
              .map((x) => t(x.name))
              .join(", ")}
            {filter.populations.length > 3 && <span>...</span>}
          </div>

          <ListCell>
            <SaveIcon status={props.filter.active.id === filter.id ? props.filter.status : null} />
          </ListCell>
        </div>
      ))}
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session,
  filter: state.filter
})

export default connect(mapStateToProps)(withTranslation()(AdmFiltersRoute))
